import "./wdyr"
import React from 'react';
import ReactDOM from 'react-dom/client';
// import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'mdb-ui-kit/css/mdb.min.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { AuthProvider } from "./context/AuthContext";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
// import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid

// import reportWebVitals from './reportWebVitals';

// ReactDOM.render(<App />,document.getElementById("root"));

// สร้าง QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // กำหนด staleTime ให้เหมาะสม (ในที่นี้ 60 วินาที)
      staleTime: 60000,
      // ปิด refetchOnWindowFocus หากไม่ต้องการรีเฟรชเมื่อกลับมาที่หน้าจอ
      refetchOnWindowFocus: false,
    },
  },
});


// ช่องตัวเลข (type="number") ทุกหน้า: มือถือให้ขึ้นแป้นตัวเลขแทนคีย์บอร์ดเต็ม
// (type="number" อย่างเดียว iPhone ยังขึ้นคีย์บอร์ดสัญลักษณ์) — ช่องที่ตั้ง inputMode เองแล้วจะไม่ถูกแตะ
document.addEventListener('focusin', (e) => {
  const el = e.target;
  if (el instanceof HTMLInputElement && el.type === 'number' && !el.hasAttribute('inputmode')) {
    el.setAttribute('inputmode', 'decimal');
  }
}, true);

// "ResizeObserver loop ..." เป็นคำเตือนที่ไม่มีผลเสียของเบราว์เซอร์ (เช่นตอนย่อหน้าจอ ตาราง AG Grid ปรับขนาดหลายรอบในเฟรมเดียว)
// แต่ dev overlay ของ CRA แสดงเป็น error เต็มจอ — กันเฉพาะข้อความนี้ ข้อผิดพลาดอื่นยังแสดงตามปกติ
window.addEventListener('error', (e) => {
  if (typeof e.message === 'string' && e.message.startsWith('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true); // capture: ทำงานก่อน listener ของ overlay ที่ลงทะเบียนไว้ก่อนโค้ดแอป

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
